import React, { useMemo, useState, useEffect } from 'react';
import { FiPlus } from "react-icons/fi";
import { notification, Spin, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { debounce, ceil, trim, capitalize } from 'lodash';
import { AiOutlineDelete } from "react-icons/ai";
import { TbPlaneArrival } from "react-icons/tb";
import { Box } from '@mui/material';
import WarningIcon from '../../../assets/icons/warning-modal-icon.svg';

import Search from '../../../components/uiComponent/inputs/searchinput';
import Button from '../../../components/uiComponent/button';
import Badge from '../../../components/uiComponent/bages';
import Modal from "../../../components/uiComponent/modal/index";
import AgGrid from "../../../components/ag-grid-table/index";
import Input from "../../../components/uiComponent/inputs/input/index"
import Pagination from '../../../components/pagination';
import Select from "../../../components/uiComponent/select/index";
import CustomTabs from "../../../components/uiComponent/customTabs"

import SideDrawerIcon from "../../../assets/icons/side-bar-icon.svg";
import EditIcon from '../../../assets/images/edit-icon.svg';
import MarkAsResolved from '../../../assets/icons/mark-as-resolved-icon.svg';

import { PoHistoryWrapper, ModalWrapper } from './style';
import AddManualProduct from '../po-details/add-Product/addProductManual';
import { CreatePo, GetPoListing, GetVendorsList, DeletePo, UpdatePo } from '../../../slices/po';
import { PO_STATUSES } from '../../../constants/threeLayer';

const defaultColDef = {
  resizable: true,
  sortable: false,
  suppressMenu: true,
  suppressMovable: true,
  suppressSorting: true,
};

let gridColumnApi

const PoHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '', poStatus: '', vendor: '' });
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const [addProduct, setAddProduct] = useState();
  const [showCreatePoModal, setShowCreatePoModal] = useState(false);
  const [createPoData, setCreatePoData] = useState({ vendorName: '', poName: '' });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState(null); 
  const [poId, setPoId] = useState(null)
  const {
    pos,
    totalPosCount,
    fetchingPos,
    vendorsList,
    fetchingVendorsList,
    creatingPo,
    deletingPo,
    userPoAllStatusCount
  } = useSelector((state) => state.pos || {});
  const { currentUser } = useSelector((state) => state.auth || {})

  useEffect(() => {
    dispatch(GetPoListing({ page, filters, sortBy }));
    dispatch(GetVendorsList());
  }, []);
  
  const handleClose = () =>{
    setIsModalOpen(false)
  }

  const statuses = [
    {
      id: 'Pending',
      label: 'Pending',
      count: userPoAllStatusCount['Pending'] || 0,
      activeBg: '#FF9900',
      inactiveBg: '#FF990033',
      activeText: '#fff',
      inactiveText: '#FF9900',
      activeCountBg: '#fff',
      inactiveCountBg: '',
      activeCountText: '#fff',
      inactiveCountText: '#FF9900',
      activeBorder: '#FF9900',
      inactiveBorder: '#FF9900',
      width: 182,
    },
    {
      id: 'Confirmed',
      label: 'Confirmed',
      count: userPoAllStatusCount['Confirmed'] || 0,
      activeBg: '#1565D8',
      inactiveBg: '#1565D833',
      activeText: '#fff',
      inactiveText: '#1565D8',
      activeCountBg: '#fff',
      inactiveCountBg: '',
      activeCountText: '#fff',
      inactiveCountText: '#1565D8',
      activeBorder: '#1565D8',
      inactiveBorder: '#1565D8',
      width: 182,
    },
    {
      id: 'Arrived',
      label: 'Arrived',
      count: userPoAllStatusCount['Arrived'] || 0,
      activeBg: '#009C34',
      inactiveBg: '#009C3433',
      activeText: '#fff',
      inactiveText: '#009C34',
      activeCountBg: '#fff',
      inactiveCountBg: '',
      activeCountText: '#fff',
      inactiveCountText: '#009C34',
      activeBorder: '#009C34',
      inactiveBorder: '#009C34',
      width: 182,
    },
    {
      id: 'Receiving',
      label: 'Receiving',
      count: userPoAllStatusCount['Receiving'] || 0,
      activeBg: '#47B5FF',
      inactiveBg: '#47B5FF33',
      activeText: '#fff',
      inactiveText: '#47B5FF',
      activeCountBg: '#fff',
      inactiveCountBg: '',
      activeCountText: '#fff',
      inactiveCountText: '#47B5FF',
      activeBorder: '#47B5FF',
      inactiveBorder: '#47B5FF',
      width: 182,
    },
    {
      id: 'Processed',
      label: 'Processed',
      count: userPoAllStatusCount['Processed'] || 0,
      activeBg: '#9747FF',
      inactiveBg: '#9747FF33',
      activeText: '#fff',
      inactiveText: '#9747FF',
      activeCountBg: '#fff',
      inactiveCountBg: '',
      activeCountText: '#fff',
      inactiveCountText: '#9747FF',
      activeBorder: '#9747FF',
      inactiveBorder: '#9747FF',
      width: 182,
    },
    {
      id: 'Deleted',
      label: 'Deleted',
      count: userPoAllStatusCount['Deleted'] || 0,
      activeBg: '#D95040',
      inactiveBg: '#D9504033',
      activeText: '#fff',
      inactiveText: '#D95040',
      activeCountBg: '#fff',
      inactiveCountBg: '',
      activeCountText: '#fff',
      inactiveCountText: '#D95040',
      activeBorder: '#D95040',
      inactiveBorder: '#D95040',
      width: 182,
    },
  ];
  const columnDefs = useMemo(() => [
    {
      headerName: 'Date',
      field: 'created_at',
      minWidth: 120,
      sortable:true,
      flex: 1,
      comparator: () => 0,
      cellRenderer: ({ value }) => {
        if (!value) return '';
        const date = new Date(value);
        return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
      },
      valueFormatter: (params) => `${params?.value || '-'}`,
    },
    {
      headerName: 'Vendor Name',
      minWidth: 130,
      flex: 1,
      field: 'vendor.name',
      cellRenderer: ({ value }) => value || '---'
    },
    {
      headerName: 'PO Name',
      minWidth: 200,
      field: 'file_name',
      flex: 1,
      cellRenderer: ({ value }) => value || '---'
    },
    {
      headerName: 'Status',
      minWidth: 120,
      flex: 1,
      field: 'status',
      cellRenderer: ({ value }) => <Badge status={capitalize(value)} />,
    },
    // {
    //   headerName: 'Total SKUs',
    //   minWidth: 100,
    //   flex: 1,
    //   field: 'total_skus',
    //   comparator: () => 0,
    //   sortable: true,
    //   cellRenderer: ({ value }) => value || 0
    // },
    // {
    //   headerName: 'Products Count',
    //   minWidth: 100,
    //   flex: 1,
    //   field: 'total_products',
    //   comparator: () => 0,
    //   sortable: true,
    //   cellRenderer: ({ value }) => value || 0
    // },
    {
      headerName: 'Ordered Quantity',
      minWidth: 130,
      flex: 1,
      field: 'ordered_quantity',
      comparator: () => 0,
      sortable: true,
      valueFormatter: (params) => `${Number(params?.value || 0)?.toLocaleString('en-US')}`,
    },
    {
      headerName: 'Invoice Quantity',
      minWidth: 120,
      field: 'invoice_quantity',
      flex: 1,
      comparator: () => 0,
      sortable: true,
      valueFormatter: (params) => `${Number(params?.value || 0)?.toLocaleString('en-US')}`,
    },
    {
      headerName: 'Received Quantity',
      minWidth: 120,
      field: 'received_quantity',
      flex: 1,
      comparator: () => 0,
      sortable: true,
      valueFormatter: (params) => `${Number(params?.value || 0)?.toLocaleString('en-US')}`,
    },
    {
      headerName: 'Missing Units',
      minWidth: 140,
      field: 'missing_units',
      sortable: true,
      flex: 1,
      comparator: () => 0,
      cellRenderer: ({ data }) => {
        const missingUnits = data?.missing_units || 0;
        return <>{missingUnits?.toLocaleString('en-US')}</>;
      }
    },
    {
      headerName: 'PO Value By Order Qty',
      field: 'po_by_order_quantity',
      minWidth: 125,
      flex: 1,
      comparator: () => 0,
      sortable: true,
      cellRenderer: ({ value = 0 }) => `$${Number(value)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
    {
      headerName: 'PO Value By Invoice Qty',
      field: 'po_value',
      minWidth: 125,
      flex: 1,
      comparator: () => 0,
      sortable: true,
      cellRenderer: ({ value = 0 }) => `$${Number(value)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
    {
      headerName: 'Action',
      field: 'action',
      minWidth: 120,
      flex: 1,
      cellRenderer: ({ data }) => {
        const isDisabled = data?.status?.toLowerCase() === 'pending' 
        return (
        <>
          {data?.status?.toLowerCase() != 'deleted' ? <img className='cursor-pointer' src={SideDrawerIcon} onClick={() => handleNavigateEditPo(data?.id)} alt="Edit PO" title='Edit PO' />
        : null}
        <AiOutlineDelete style={(data?.status?.toLowerCase() != 'pending' ) ? { opacity: 0.5, cursor: 'not-allowed' } : {}} className='delete-icon' onClick={
          data?.status?.toLowerCase() === 'pending' 
          ? 
          ()=>{
          setIsModalOpen(true)
          setPoId(data?.id)
          } 
          : null
          }/>
        </>
      )},
    },
  ], []);

  const handleSearchPo = debounce((value) => {
    if (trim(value) || filters.search) {
      setFilters(filters => ({ ...filters, search: trim(value) }));
      setPage(page => ({ ...page, pageNumber: 1 }));
      dispatch(GetPoListing({
        page: { ...page, pageNumber: 1 },
        filters: { ...filters, search: trim(value) },
        sortBy
      }));
    }
  }, 800);

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    dispatch(GetPoListing({
      page: newPage,
      filters,
      sortBy
    }));
  };

  const gridReady = (params) => {
    gridColumnApi = params.columnApi
  }

  const refreshGridClick = () => {
      if (gridColumnApi){
        gridColumnApi.applyColumnState({
          defaultState: { sort: null },
          applyOrder: true,
        });
        setSortBy({ key: '', type: '' })
      }
    dispatch(GetPoListing({
      page,
      filters,
    }))
  };

  const handleNavigateEditPo = (id) => {
    navigate(`/po-details/${id}`)
  }

  const handleNavigateReceivePo = (id) => {
    navigate(`/po-warehouse-details/${id}`)
  }

  const { pageNumber, pageSize } = page || {};

  const handleFilterChange = ({ key, value }) => {
    setFilters(filters => ({ ...filters, [key]: value }));
    setPage(page => ({ ...page, pageNumber: 1 }));
    dispatch(GetPoListing({
      page: { ...page, pageNumber: 1 },
      filters: { ...filters, [key]: value },
      sortBy
    }));
  };

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null)

    if (value && ['ordered_quantity', 'received_quantity', 'po_value', 'po_by_order_quantity', 'total_skus', 'total_products', 'invoice_quantity', 'created_at', 'missing_units'].includes(value?.colId)) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      dispatch(GetPoListing({
        page,
        filters,
        sortBy: { key: colId, type: sort }
      }));
    }
  };

  const handleCloseCreatePoModal = () => {
    setShowCreatePoModal(false);
    setCreatePoData({ poName: '', vendorName: '' });
  };

  const handleCreatePo = () => {
    const matchedEntries = pos.filter(({ file_name }) => file_name === createPoData.poName);
    if (matchedEntries?.length) {
      return notification.error({
        top: 65,
        message: 'Create PO',
        description: 'PO name must be unique'
      });
    }

    dispatch(CreatePo({
      ...createPoData
    })).then(({ payload }) => {
      if (payload?.success) handleCloseCreatePoModal();
      refreshGridClick();
    });
  };

  return (
    <PoHistoryWrapper>
      <div className='bar-item'>
        <Search
          className="search"
          placeholder="Search by PO Name, UPC"
          onChange={({ target }) => handleSearchPo(target.value)}
        />
        <div className='po-inputs'>
          <Select
            isClearable={true}
            placeholder="Vendor"
            className="mb-0"
            loading={fetchingVendorsList}
            options={vendorsList}
            onChange={(e) => handleFilterChange({ key: 'vendor', value: e?.value })}
          />
          {/* <Select
            isClearable={true}
            placeholder="PO Status"
            className="mb-0"
            options={PO_STATUSES}
            onChange={(e) => handleFilterChange({ key: 'poStatus', value: e?.value })}
          /> */}
          <Button onClick={() => setShowCreatePoModal(true)} className="outlined import-btn-po" startIcon={<FiPlus />} text="Create Purchase Order" />
          <Button onClick={() => setAddProduct(true)} className="outlined import-btn-po" startIcon={<FiPlus />} text="Create PO by File Upload" />
        </div>
      </div>
      <Box mb={2}>
        <CustomTabs
          tabs={[
            {
              id: null,
              label: 'All',
              content: null,
              activeBg: '#1565D8',
              inactiveBg: '#E0E7FF',
              activeText: '#ffffff',
              inactiveText: '#1D4ED8',
              activeCountBg: '#ffffff',
              inactiveCountBg: '#E0E7FF',
              activeCountText: '#1D4ED8',
              inactiveCountText: '#1D4ED8',
              activeBorder: '#ffffff',
              inactiveBorder: '#1D4ED8',
              width: 100
            },
            ...statuses.map((status) => ({
              ...status,
              content: null,
            })),
          ]}
          activeTab={activeStatus}
          onTabClick={(id) => {
            setActiveStatus(id);
            handleFilterChange({ key: 'poStatus', value: id });
          }}
        />
      </Box>
      <Spin tip='Loading...' spinning={fetchingPos}>
        <AgGrid
          gridReady={gridReady}
          user_referrals={pos}
          defaultColDef={defaultColDef}
          columnDefinitions={columnDefs}
          rowHeight={64}
          headerHeight={36}
          height="282px"
          masterDetail={false}
          detailRowAutoHeight={false}
          onSortChange={onSortChange}
          className="sku-table"
        />
      </Spin>
      <Pagination
        total={totalPosCount}
        totalPages={ceil(totalPosCount / pageSize + 1)}
        pageNumber={pageNumber}
        pageLimit={pageSize}
        handleLimitChange={(e) => handlePagination(e, 'pageSize')}
        handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
        handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
        refreshGridClick={refreshGridClick}
      />
      <AddManualProduct refreshGridClick={refreshGridClick} addProduct={addProduct} setAddProduct={setAddProduct} />
      <Modal
        open={showCreatePoModal}
        onClose={handleCloseCreatePoModal}
        onHide={handleCloseCreatePoModal}
        closeText="Cancel"
        saveText="Confirm"
        header="Delete Confirmation"
        heading="Create Purchase Order"
        className="delete-confirmation-modal po-details-create-header"
        closeButton={true}
        onSave={handleCreatePo}
        buttonDisabled={!createPoData?.poName || !createPoData?.vendorName || creatingPo}
      >
        <PoHistoryWrapper>
          <Spin tip='Loading...' spinning={creatingPo}>
            <div className='crate-po-wrapper'>
              <Select
                isClearable={true}
                label="Vendor"
                important
                placeholder="Select Vender"
                className="mb-0"
                loading={fetchingVendorsList}
                options={vendorsList}
                onChange={(e) => {
                  const vendorName = e?.value;
                  let poName = '';
                  if (vendorName) {
                    poName = `${vendorName}-${dayjs().format('DD-MM-YYYY')}`;
                    const matchedEntries = pos.filter(({ file_name }) => file_name.includes(poName));
                    poName += `-${(matchedEntries?.length || 0) + 1}`;
                  }
                  setCreatePoData({ vendorName, poName });
                }}
              />
              <Input
                height="32px"
                label="PO Name"
                important
                value={createPoData?.poName}
                placeholder="PO Name here"
                onChange={({ target }) => setCreatePoData(poData => ({ ...poData, poName: target?.value }))}
              />
            </div>
          </Spin>
        </PoHistoryWrapper>
      </Modal>
      <Modal
        open={isModalOpen}
        onClose={handleClose}
        onHide={handleClose}
        buttonDisabled = {deletingPo}
        closeText='Cancel'
        saveText='Confirm'
        header='Arrived Confirmation'
        className='delete-confirmation-modal'
        closeButton={true}
        onSave={() => {
          dispatch(DeletePo(poId)).then(({ payload }) => {
            if (payload?.success) setIsModalOpen(false)
              refreshGridClick();
          });
        
        }}
      >
        <ModalWrapper>
          <div className='delete-modal-wrapper'>
            <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
            <h3>Delete PO</h3>           
              <p>Do You Want To Delete This PO?</p>
          </div>
          </ModalWrapper>
      </Modal>
    </PoHistoryWrapper>
  );
};

export default PoHistory;
